// import React, { lazy, Suspense, useEffect, useRef, useState } from 'react'
// import { useNavigate, } from 'react-router-dom'
// import { useAuth } from '../../components/context/Auth'
// import { CrossRedIcon, DoubleCheckIcon, Spinner } from '../../components/icons/Icon'
// import styles from "./Dealer.module.css"
// import ModalWrapper from '../../components/updatedComponents/layoutWrapper/ModalWrapper'
// import { ArroIcon, CreateTem, TemplateNotFound, Transfer, WhatAppIcon, } from '../../components/icons/Icon2'
// import SlidingFilter from '../../components/updatedComponents/Dealers/SlidingFilter'
// import DealerStatusCard from '../../components/updatedComponents/Dealers/DealerStatusCard'
// import SearchBar from '../../components/updatedComponents/FormComponents/SearchBar'
// import DropDown from "../../components/updatedComponents/FormComponents/DropDown"
// import AdduserModel from '../../components/updatedComponents/models/AdduserModel'
// import FilterCard from '../../components/updatedComponents/MobilCard/FilterCard'
// import DealerCartMobil from '../../components/updatedComponents/MobilCard/DealerCartMobil'
// import Pagenation from "../../components/updatedComponents/Pagnation/Pagenation"
// import GoToPage from '../../components/updatedComponents/Pagnation/GoToPage'
// import Skeleton from '../../components/updatedComponents/Skeleton/Skeleton'
// import fetchData from '../../APIsControll/apiControll'
// import { useToast } from '../../components/updatedComponents/Toaster/Toaster'
// import InputTag from '../../components/updatedComponents/FormComponents/InputTag'
// import Button from '../../components/updatedComponents/Dealers/Button'
// import TopTabBar from '../../components/updatedComponents/Tanolet/TopTabBar'
// import LocationSarchFilter from '../../components/updatedComponents/Filter/LocationSarchFilter'
// import NoDataFound from '../../components/updatedComponents/NoDataFound/NoDataFound'
// import useWindowWidth from '../../components/updatedComponents/Hooks/WidthSize'
// const DealerInfoCard = lazy(() => import("../../components/updatedComponents/Dealers/DealerInfoCard"));
// const TempletSent = lazy(() => import("../../components/updatedComponents/Dealers/TempletSent"));
// const Dealers = () => {
//   const { mode, designation } = useAuth()
//   const { show } = useToast()
//   const navigate = useNavigate();
//   const [page, setPage] = useState(1);
//   const [isloading, setIsLoading] = useState({
//     Isloading1: false
//   });
//   const [chackState, setChackState] = useState({
//     chackStates: false
//   });

//   const [selectTemp, setSelectTemp] = useState("Select Template");
//   const [showSelectTemp, setShowSelectTemp] = useState(false);
//   const [dealerData, setDealerData] = useState([])
//   const [dealerNumber, setDealerNumber] = useState([])
//   const { managerId } = useAuth()
//   const [loading, setLoading] = useState(false)
//   // const [width, setWidth] = useState(window.innerWidth);
//   const width = useWindowWidth()
//   const [showMessengerModal, setShowMessengerModal] = useState(false)
//   const [sendTemplateModal, setSendTemplateModal] = useState(false)
//   const [sendTemplateText, setSendTemplateText] = useState('')
//   const [allTemplate, setAllTemplate] = useState([]);
//   const [singleTemplate, setSingleTemplate] = useState({});
//   const [messengerTemplate, setMessengerTemplate] = useState();
//   const [dealerNames, setDealerNames] = useState([]);
//   const [showDealerNames, setShowDealerNames] = useState(false);
//   const [selectedNumber, setSelectedNumber] = useState([]);
//   const [templateError, setTemplateError] = useState();
//   const [templateDataLoading, setTemplateDataLoading] = useState(false);
//   const [sendStatus, setSendStatus] = useState({});
//   const [templatePage, setTemplatePage] = useState(1);
//   const [totalPage, setTotalPage] = useState(3);
//   const [allfilter, setAllFilter] = useState([]);
//   const [page1, setPage1] = useState(1);
//   const [pages1, setPages1] = useState(1);


//   const [state, setState] = useState({
//     locationList: [],
//     searchValue: "",
//     selectFilter: []
//   })
//   const [District, setDistrict] = useState({
//     locationList: [],
//     searchValue: "",
//     selectFilter: []
//   })
//   const [City, setCity] = useState({
//     locationList: [],
//     searchValue: "",
//     selectFilter: []
//   })


//   const sliceData = (data, page) => {
//     const pageSize = dealerNumber.length;
//     // const pageSize = 2; 
//     // const pageSize = 1000; 
//     if (page === 1) {
//       return data.slice(0, pageSize);
//     } else if (page === 2) {
//       return data.slice(pageSize, pageSize * 2);
//     } else if (page === 3) {
//       return data.slice(pageSize * 2, pageSize * 3);
//     } else if (page === 4) {
//       return data.slice(pageSize * 3);
//     } else {
//       return [];
//     }
//   };
//   const slicedData = sliceData(dealerNumber, templatePage);

//   const [searchDealerData, setSearchDealerData] = useState({
//     searchDealerName: '',
//     sortByStatus: '',
//     sortKey: '',
//     dateFilter: '',
//     district: '',
//     status: 'All',
//   });
//   const [pages, setPages] = useState(1);


//   useEffect(() => {
//     if (managerId) {
//       const getDealers = async () => {
//         try {
//           setLoading(true);
//           const res = await fetchData(`kyc/dealers?page=${page}&limit=${32}`, {
//             managerId,
//             keyword: searchDealerData.searchDealerName,
//             sortKey: searchDealerData.sortKey,
//             status: searchDealerData.status,
//             day: searchDealerData.dateFilter === "All" ? "" : searchDealerData.dateFilter.toLocaleLowerCase(),
//             locations: {
//               states: state.selectFilter,
//               districts: District.selectFilter,
//               cities: City.selectFilter,
//               pincodes: [],

//             }
//           });

//           if (res.status === "success") {
//             setAllFilter(res);

//             if (res?.data) {
//               // Update dealer data
//               setDealerData((prevDealerData) => {
//                 const newData = res?.data;
//                 if (
//                   searchDealerData.dateFilter ||
//                   searchDealerData.searchDealerName ||
//                   searchDealerData.sortByStatus ||
//                   searchDealerData.status
//                 ) {
//                   return newData; // Override with filtered data
//                 }

//                 const mergedData = [...prevDealerData, ...newData];
//                 const uniqueData = mergedData.filter(
//                   (item, index, self) => index === self.findIndex((t) => t.dealerId === item.dealerId)
//                 );
//                 return uniqueData;
//               });

//               setPages(res?.pages || 1);
//             }
//           } else if (res.status === "failed") {
//             setDealerData([])
//             setPage(1);
//             // show(res.msg || "Something went wrong", "error");
//           } else {
//             show("Error", "error");
//           }
//         } catch (error) {
//           console.error("Error fetching dealers:", error);
//           show("An unexpected error occurred", "error");
//         } finally {
//           setLoading(false); // Always stop loading, even in case of an error
//         }
//       };
//       getDealers();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [managerId, page, searchDealerData, state.selectFilter, District.selectFilter, City.selectFilter,]);


//   useEffect(() => {
//     const getDealerLoction = async () => {
//       try {
//         const payload = {
//           managerId: managerId,
//           stateSearch: "",
//           districtSearch: "",
//           citySearch: "",
//           pincodeSearch: "",
//           locations: {
//             states: [],
//             districts: [],
//             cities: [],
//             pincodes: []
//           }
//         }
//         const res = await fetchData(`wallikonCampaign/filterLocation`, payload);
//         setDistrict((pre) => ({ ...pre, locationList: res?.data?.districts }));
//         setState((pre) => ({ ...pre, locationList: res?.data?.states }));
//         setCity((pre) => ({ ...pre, locationList: res?.data?.cities }));
//       } catch (error) {

//       }
//     }
//     getDealerLoction();
//   }, [managerId])

//   const dealerNumberData = async () => {
//     const res = await fetchData(`kyc/dealerWhatsapp`, { "managerId": managerId });
//     if (res.status === "success") {
//       // setDealerNumber(res?.dealerWhatsapp);
//       setDealerNumber([{
//         "dealerId": 9161048556,
//         "name": "Mohit",
//         "whatsapp": 9161048556
//       },
//       {
//         "dealerId": 6392457271,
//         "name": "Anshu Bhai",
//         "whatsapp": 6392457271
//       },
//       {
//         "dealerId": 9151637187,
//         "name": "Asmit Bhai",
//         "whatsapp": 9151637187
//       },
//       ]);
//       return
//     }
//     if (res.status === "failed") {
//       show(`${res?.msg}`, "error");
//       return
//     } else {
//       show(`Error`, "error");
//     }
//   };

//   useEffect(() => {
//     if (managerId) {
//       if (designation === "superadmin") {
//         dealerNumberData()
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [managerId])

//   useEffect(() => {
//     if (dealerData.dealerId) {
//       navigate("/dealers/" + dealerData?.dealerId)
//     }
//   }, [dealerData.dealerId, navigate])

//   const sendMessage = async () => {
//     setTemplateDataLoading(true);
//     const myHeaders = new Headers();
//     myHeaders.append("wa-platform", process.env.REACT_APP_ADMIN_SECRET);
//     myHeaders.append("Content-Type", "application/json");

//     const rawData = {
//       managerId: managerId,
//       dealerPhoneNumber: selectedNumber,
//       templateName: singleTemplate.templateName,
//       languageCode: singleTemplate.language,
//       headerType: singleTemplate.headerType,
//       headerId: singleTemplate.headerId,
//     };
//     if (singleTemplate.headerType === 'document') {
//       rawData.documentFilename = singleTemplate.documentName;
//     }
//     if (singleTemplate.headerType === 'location') {
//       rawData.latitude = "26.8428008";
//       rawData.longitude = "80.9359821";
//       rawData.locationName = "Wallicon Private Limited";
//       rawData.locationAddress = "Wallicon, Burlington, Aminabad Road, Lucknow";
//       // rawData.buttonIndex = "1";
//       // rawData.buttonDataPayload = "https://dealer.wallicon.in/payment-order/Wal54LhjZqiN14";
//     }

//     // Convert the object to a JSON string
//     const raw = JSON.stringify(rawData);
//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: raw,
//       redirect: "follow",
//     };

//     const controller = new AbortController();
//     const signal = controller.signal;
//     // 5 minutes timeout (300000 milliseconds)
//     const timeoutId = setTimeout(() => controller.abort(), 300000);

//     fetch(process.env.REACT_APP_URL + "wallikonChat/sendTemplate?page=" + templatePage, {
//       ...requestOptions,
//       signal: signal
//     })
//       .then((response) => response.json())
//       .then(result => {
//         clearTimeout(timeoutId);
//         if (result.status === 'failed') {
//           alert(result.msg);
//           setTemplateError(result.msg);
//         }
//         setTemplateDataLoading(false);
//         processResult(result?.results);
//         setSendStatus(result.response);
//         // console.log("processResult");
//         if (templatePage < totalPage) {
//           setTemplatePage(prevPage => prevPage + 1);
//         }

//         setTotalPage(result.response.totalPages);
//       })
//       .catch((error) => {
//         clearTimeout(timeoutId); // Clear the timeout on error
//         if (error.name === 'AbortError') {
//           console.error("Request timeout, it took too long");
//         } else {
//           console.error(error);
//         }
//       });
//   };

//   const processResult = (results) => {
//     if (!slicedData || !Array.isArray(slicedData)) {
//       console.error("slicedData is undefined or not an array");
//       return;
//     }

//     const newStatusArray = slicedData.map(dealer => {
//       const foundResult = results.find(result => {
//         const input = result?.data?.contacts?.[0]?.input || result?.data?.to;
//         return input && (input.toString() === dealer.whatsapp.toString());
//       });

//       if (foundResult) {
//         return {
//           whatsapp: dealer.whatsapp,
//           name: dealer.name,
//           status: foundResult.status
//         };
//       } else {
//         return {
//           whatsapp: dealer.whatsapp,
//           name: dealer.name,
//           status: 'failed'
//         };
//       }
//     });

//     setDealerNames(newStatusArray);
//     handleAddTemplateRecord(newStatusArray);
//   };

//   const handleAddTemplateRecord = (statusInfo) => {
//     const myHeaders = new Headers();
//     myHeaders.append("wa-platform", process.env.REACT_APP_ADMIN_SECRET);
//     myHeaders.append("Content-Type", "application/json");

//     const raw = JSON.stringify({
//       "managerId": managerId,
//       "templateName": singleTemplate.templateName,
//       "statusInfo": statusInfo
//     });

//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: raw,
//       redirect: "follow"
//     };

//     fetch(process.env.REACT_APP_URL + "wallikonChat/addUpTempstatus", requestOptions)
//       .then((response) => response.json())
//       .then((result) => {
//         if (result.status === 'success') {
//           // setTemplateData(result.data)
//         }
//       })
//       .catch((error) => console.error(error));
//   }

//   const [addDealerModelOpen, setAddDealerModelOpen] = useState(false)
//   const addDelalerModel = () => {
//     setAddDealerModelOpen(!addDealerModelOpen)
//   }
//   const TempletSentModel = () => {
//     setShowMessengerModal(!showMessengerModal)
//   }
//   const itemList = [" All", "Today", "Yesterday", "Month"];
//   const dealerStatusData = [
//     { statusText: "All", statusItemCount: allfilter?.total || 0 },
//     { statusText: "New", statusItemCount: allfilter?.statusCounts?.New || 0 },
//     { statusText: "Verified", statusItemCount: allfilter?.statusCounts?.Verified || 0 },
//     { statusText: "Pending", statusItemCount: allfilter?.statusCounts?.Pending || 0 },
//     { statusText: "Update", statusItemCount: allfilter?.statusCounts?.Update || 0 },
//     { statusText: "Rejected", statusItemCount: allfilter?.statusCounts?.Rejected || 0 },
//     { statusText: "Deleted", statusItemCount: allfilter?.statusCounts?.Deleted || 0 },
//     { statusText: "Blacklisted", statusItemCount: allfilter?.statusCounts?.Blacklisted || 0 },
//   ];

//   const updateDateFilter = (selectedDate) => {
//     setSearchDealerData((prevData) => ({
//       ...prevData,
//       dateFilter: selectedDate,
//     }));
//   };
//   const containerRef = useRef(null);

//   const handleScroll = () => {
//     const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
//     // Allow a small tolerance (e.g., 5px) for the scroll comparison
//     const bottom = Math.abs(scrollHeight - scrollTop - clientHeight) <= 5;

//     if (bottom && !loading) {
//       if (page >= pages) {
//         return;
//       } else {
//         setPage((prevPage) => Number(prevPage) + 1);
//       }
//     }
//   };

//   useEffect(() => {
//     const container = containerRef.current;

//     if (container) {
//       container.addEventListener('scroll', handleScroll);
//     }

//     return () => {
//       if (container) {
//         container.removeEventListener('scroll', handleScroll);
//       }
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loading, page]);

//   async function getTemplates() {
//     if (managerId) {
//       if (page1 <= pages1) {
//         setIsLoading({ ...isloading, Isloading1: true });
//         const res = await fetchData(`wallikonChat/templateList?page=${page1 <= pages1 ? page1 : pages1}&&limit=10`, {
//           "managerId": managerId
//         });
//         if (res?.status === 'success') {
//           // setAllTemplate(res?.data);
//           const newTemplates = res?.data || [];

//           // Filter out templates that already exist in allTemplate
//           const filteredTemplates = newTemplates.filter(newTemplate =>
//             !allTemplate.some(existingTemplate =>
//               existingTemplate.templateName === newTemplate.templateName
//             )
//           );

//           setAllTemplate([...allTemplate, ...filteredTemplates]);
//           // setPage1(res.page);
//           setPages1(res?.pages);
//           setIsLoading({ ...isloading, Isloading1: false });
//           return
//         }
//         if (res?.status === 'failed') {
//           show(`${res?.msg}`, "error");
//           setIsLoading({ ...isloading, Isloading1: false });
//           return
//         } else {
//           show(`Error`, "error");
//           setIsLoading({ ...isloading, Isloading1: false });
//         }
//       }
//     }
//   };

//   useEffect(() => {
//     if (designation === "superadmin") {
//       getTemplates();
//     }

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [page1]);

//   const handleSelectAllNumber = () => {
//     setSelectedNumber(dealerNumber.map(number => number?.whatsapp));
//   };
//   useEffect(() => {
//     setMessengerTemplate(selectTemp);
//     const selectedTemplate = allTemplate.find(item => item?.templateName === selectTemp);
//     if (selectedTemplate) {
//       setSingleTemplate(selectedTemplate);
//     } else if (selectTemp === 'custom_value') {
//       setSingleTemplate({ templateName: 'custom_value' });
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectTemp]);


//   const handleChack = (e) => {
//     if (e === true && selectTemp !== "Select Template") {
//       handleSelectAllNumber();
//       setChackState({ ...chackState, chackStates: true });
//       return
//     }
//     else {
//       setChackState({ ...chackState, chackStates: false })
//     }
//   };

//   const handleSendTemplate = () => {
//     setShowDealerNames(true);
//     sendMessage();
//     setShowMessengerModal(false);
//     // setSendTemplateModal(false);
//   };

//   const handeclose = () => {
//     setShowDealerNames(false);
//     // setSelectedNumber([]);
//     // setMessengerTemplate();
//     setSendTemplateText('');
//   };

//   // const handleUpdate = (item) => {
//   //   addDelalerModel();
//   // };


//   return (
//     <React.Fragment>

//       <ModalWrapper
//         closeBtn={showMessengerModal}
//         text={"Hello"}
//         isOpen={showMessengerModal} onClose={TempletSentModel}>
//         <Suspense fallback={
//           <div className={styles.TempContiner} style={{ backgroundColor: mode ? "#232529" : "#fff" }}>
//             <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
//               <div style={{ width: "30%" }}>
//                 <Skeleton lines={1} thickness={3} />
//               </div>
//               <div style={{ width: "90%", alignSelf: "center", marginTop: "10px" }}>
//                 <Skeleton lines={1} thickness={5} />
//                 <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
//                   <div style={{ width: "30%" }} > <Skeleton lines={1} thickness={3} />  </div>
//                   <div style={{ width: "30%" }} > <Skeleton lines={1} thickness={3} />  </div>
//                 </div>
//                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                   <div style={{ width: "48%" }} > <Skeleton lines={1} thickness={5} />  </div>
//                   <div style={{ width: "48%" }} > <Skeleton lines={1} thickness={5} />  </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         }>
//           <TempletSent
//             selectTemp={selectTemp}
//             setSelectTemp={setSelectTemp}
//             setShowSelectTemp={setShowSelectTemp}
//             showSelectTemp={showSelectTemp}
//             templist={allTemplate}
//             page={page1}
//             pages={pages1}
//             setPage={setPage1}
//             loading={isloading?.Isloading1}
//             closeBtn={TempletSentModel}
//             SendTemplateModal={setSendTemplateModal}
//             chackValue={handleChack}
//             disabledValue={chackState.chackStates}
//             selectedNumber={selectedNumber}
//             key={"1"}
//           />
//         </Suspense>
//       </ModalWrapper>

//       <ModalWrapper isOpen={sendTemplateModal} onClose={() => setSendTemplateModal(!sendTemplateModal)}>
//         <div className={styles.text_center} style={{ backgroundColor: mode ? "#2C2E33" : "#fff", color: mode ? "#fff" : "#000" }}   >
//           <div className={styles.textContiner}>
//             <span className={styles.TempContinerText}>Send Template </span>
//             <p className={`${styles.message}`}>Price of Template sending is <span style={{ color: "#F93E3E" }} >{selectedNumber.length * (singleTemplate.category === 'MARKETING' ? 0.73 : singleTemplate.category === 'UTILITY' ? 0.30 : 0)}</span></p>
//             <InputTag
//               labelText={"Type Send For Send"}
//               name={"temp"}
//               maxLength={4}
//               required={true}
//               star={true}
//               placeholderText={"Type Send"}
//               placeholderType={"text"}
//               onChange={(e) => setSendTemplateText(e.target.value)}
//               value={sendTemplateText}
//             />
//             <div className={styles.massageModal_btn}>
//               <Button buttonBgColor={"#000"} buttonTextColor={"#fff"} buttonText={"No"} buttonClick={() => { setSendTemplateModal(false); setSelectedNumber([]); setMessengerTemplate() }} />
//               <Button
//                 buttonText={"Yes"}
//                 buttonTextColor={"#fff"}
//                 buttonBgColor={"#4164E3"}
//                 disabledButtonBgColor={"#2f4697"}
//                 disabledButtonTextColor={"#646B88"}
//                 disabled={sendTemplateText.toUpperCase() === 'SEND' ? false : true}
//                 buttonClick={handleSendTemplate}
//               />
//             </div>
//           </div>
//         </div>
//       </ModalWrapper>

//       <ModalWrapper isOpen={showDealerNames} closeBtn={() => setShowDealerNames(!showDealerNames)} >
//         <div className={styles.text_center} style={{ backgroundColor: mode ? "#2C2E33" : "#fff", color: mode ? "#fff" : "#000" }}   >
//           <div className={styles.AbortControllerCon}>
//             <span className={styles.template_name}>{messengerTemplate + ' Template Sent'}</span>
//           </div>
//           <div className={styles.dealerNames_div}>
//             {dealerNames && dealerNames.map((item, index) =>
//               <div key={index} className={styles.dealerNames}><span>{index + 1}&nbsp;</span>
//                 <span className='me-1'>{item?.name}-{item?.whatsapp}</span>
//                 <span>{item?.status === 'success' ? <DoubleCheckIcon /> :
//                   item?.status === 'not send' ? 'not send' : <CrossRedIcon />}</span></div>)}
//           </div>
//           {templateError ?
//             <p className='text-center'>{templateError}</p>
//             :
//             <>
//               {templateDataLoading ? <Spinner css={styles.spinnerWhite} size="24" /> :
//                 <div className='d-flex justify-content-between'>
//                   <div style={{ color: "#4164E3" }}>Total - {sendStatus.total && sendStatus.total}</div>
//                   <div style={{ color: "green" }}>Success - {sendStatus.successful && sendStatus.successful}</div>
//                   <div style={{ color: "red" }}>Failed - {sendStatus.failed && sendStatus.failed}</div>
//                 </div>}
//             </>
//           }
//           <div className={styles.dealerNameModal_btn}>
//             <Button buttonBgColor={"#000"} buttonText={"CLOSE"} buttonTextColor={"#fff"} buttonClick={handeclose} />
//             {/* <GreenOutButton title="CLOSE" handleSubmit={() => { setShowDealerNames(false); setSelectedNumber([]); setMessengerTemplate(); setSendTemplateText('') }} /> */}
//           </div>
//         </div>
//       </ModalWrapper>

//       <ModalWrapper isOpen={addDealerModelOpen} onClose={addDelalerModel} text={"Add Dealer"} closeBtn={true} >
//         <div>
//           <div style={{ height: "10px" }}></div>
//           <AdduserModel focus={true} close={addDelalerModel} />
//         </div>
//       </ModalWrapper>


//       <div className={styles.right_main}>
//         <div className={styles.sacandMainCon} style={{
//           backgroundColor: mode ? "#2C2E33" : "#fff"
//         }}>
//           <div className={width > 380 ? (mode ? styles.Dealer_main_container :
//             styles.Dealer_main_container_white) : 'default-class'}>
//             <div className={styles.addDealers}>
//               {width < 1130 ? null :
//                 <div><TopTabBar text={"Dealer"} /></div>
//               }
//               <div className={styles.btnContiner} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }} >
//                 <div style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "flex-start", }} >
//                   <div>
//                     <SlidingFilter itemList={itemList} setFilter={updateDateFilter} />
//                   </div>
//                   <div style={{ display: "flex", gap: "8px" }} >
//                     {
//                       width > 947 ?
//                         designation === "superadmin" ?
//                           <div >
//                             <Button
//                               buttonBgColor={"#fff"}
//                               buttonText={"Messenger"}
//                               buttonTextColor={"#647BB9"}
//                               buttonIcon={<WhatAppIcon />}
//                               buttonClick={() => {
//                                 setShowMessengerModal(true);
//                                 dealerNumberData();
//                               }}
//                             />
//                           </div> : null : null
//                     }
//                     <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
//                       {
//                         designation === "superadmin" ?
//                           <div >
//                             <Button
//                               buttonBgColor={"#000000"}
//                               buttonText={"Transfer Dealer"}
//                               buttonTextColor={"#fff"}
//                               buttonIcon={<Transfer />}
//                               buttonClick={() => navigate("/dealers/transferdealer")}
//                             />
//                           </div> : null
//                       }
//                       <div>
//                         <Button
//                           buttonBgColor={"#4164E3"}
//                           buttonText={"Add Dealer"}
//                           buttonIcon={<CreateTem />}
//                           buttonTextColor={"#fff"}
//                           buttonClick={() => setTimeout(() => {
//                             addDelalerModel()
//                           }, 100)}
//                         />
//                       </div>
//                       {/* <button className={styles.btnAdddelaer} onClick={addDelalerModel} >{"+"} Add Dealer</button> */}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div style={{ width: "100%", position: "relative", height: "100%", marginTop: "10px" }}>
//               <div className={styles.test_middle}
//                 style={mode ? { backgroundColor: "#232529", position: "relative", overflow: "hidden" } :
//                   { position: "relative", overflow: "hidden" }}
//               >
//                 <Suspense fallback={<>
//                   {Array.from({ length: 5 }).map((_, i) =>
//                     <div style={{ height: "100%", width: "150px", }} key={i}>
//                       <div style={{ height: "2rem", width: "50%" }}>
//                         <Skeleton thickness={2} shape='circle' />
//                       </div>
//                       <Skeleton thickness={4} lines={2} />
//                     </div>
//                   )}
//                 </>}>
//                   <div style={{ width: "100%", display: "flex", overflowX: "scroll", gap: "8px" }}
//                     className={styles.scrollable}>
//                     {dealerStatusData.map((status, index) => (
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           minWidth: "160px",
//                           width: "100%",
//                           cursor: "pointer"
//                         }}
//                         key={index}
//                         onClick={() => {
//                           setSearchDealerData((pre) => ({ ...pre, status: status?.statusText }));
//                           setPages(1)
//                         }
//                         }
//                         className={`${styles.receipts_filter} ${mode ? styles.receipts_filter_dark : ""
//                           } ${status.statusText === searchDealerData.status
//                             ? mode
//                               ? styles.receipts_filter_active_dark
//                               : styles.receipts_filter_active
//                             : ""
//                           }`}
//                       >
//                         <DealerStatusCard
//                           dealerStatus={status?.statusText}
//                           statusText={status?.statusText}
//                           statusItemCount={status?.statusItemCount}
//                         />
//                       </div>
//                     ))}
//                   </div>
//                 </Suspense>
//               </div>
//             </div>

//             <div className={styles.test_bottom}
//               style={mode ? { backgroundColor: "#2C2E33", } :
//                 { backgroundColor: "#F8F9FC" }}>
//               {width < 669 ? null :
//                 <div className={styles.test_bottom_top}>
//                   <Suspense fallback={<div>Loading..</div>}>
//                     <div className={styles.filterContiner}>
//                       <div className={styles.filterserch} >
//                         <SearchBar
//                           // borderRadius={"3px"}
//                           // padding={"5px 10px"}
//                           onChange={(e) =>
//                             setSearchDealerData({ ...searchDealerData, searchDealerName: e.target.value })}
//                           placeholder={"Search..."}
//                           // type={"password"}
//                           fontSize={12}
//                         />
//                       </div>
//                       <div className={styles.test_bottom_top_right}>
//                         <LocationSarchFilter
//                           text={"State"}
//                           list={state.locationList}
//                           search={state.searchValue}
//                           setSearch={(value) =>
//                             setState((prevState) => ({ ...prevState, searchValue: value }))
//                           }
//                           selectFilter={state.selectFilter}
//                           setSelectFilter={(value) =>
//                             setState((prevState) => ({ ...prevState, selectFilter: value }))
//                           }
//                         />
//                         <LocationSarchFilter
//                           text={"District"}
//                           list={District.locationList}
//                           search={District.searchValue}
//                           setSearch={(value) =>
//                             setDistrict((prevState) => ({ ...prevState, searchValue: value }))
//                           }
//                           selectFilter={District.selectFilter}
//                           setSelectFilter={(value) =>
//                             setDistrict((prevState) => ({ ...prevState, selectFilter: value }))
//                           }
//                         />
//                         <LocationSarchFilter
//                           text={"City"}
//                           list={City.locationList}
//                           search={City.searchValue}
//                           setSearch={(value) =>
//                             setCity((prevState) => ({ ...prevState, searchValue: value }))
//                           }
//                           selectFilter={City.selectFilter}
//                           setSelectFilter={(value) =>
//                             setCity((prevState) => ({ ...prevState, selectFilter: value }))
//                           }
//                         />

//                         <DropDown label={"Sort By"} options={[
//                           { label: "Referral", value: "Referral" },
//                           { label: "Without OTP", value: "Without OTP" },
//                           { label: "Managers Created", value: "Managers Created" },
//                           { label: "Self Created", value: "Self Created" },
//                           // { label: "New" },//
//                           // { label: "newestfirst" },//
//                           // { label: "Pending" },//
//                           // { label: "Verified" }, // 
//                           { label: "Ascending", value: "Ascending" },
//                           { label: "Descending", value: "Descending" },
//                         ]}
//                           onSelect={(val) => setSearchDealerData((pre) => ({ ...pre, sortKey: val.value }))}
//                           onReject={() => setSearchDealerData((pre) => ({ ...pre, sortKey: "" }))}
//                         />
//                       </div>
//                     </div>
//                   </Suspense>
//                 </div>
//               }
//               <div className={styles.mainIS}>
//                 <div className={styles.test_bottom_bottom} ref={containerRef} >
//                   <Suspense fallback={
//                     <div style={{ width: "100%", display: "flex", flexWrap: "wrap", gap: "10px", }} >
//                       {Array.from({ length: 28 }).map((_, i) =>
//                         <div style={{ width: "19%" }} key={i} >
//                           <Skeleton thickness={6} shape='circle' width='50px' height='50px' />
//                           <div style={{ width: "75%" }}> <Skeleton lines={3} thickness={1} />  </div>
//                           <Skeleton lines={1} thickness={3} />
//                         </div>
//                       )}
//                     </div>}>
//                     {dealerData.length === 0 ? (
//                       loading ? (
//                         Array.from({ length: 28 }).map((_, index) => (
//                           <div key={index} style={{ width: "100%" }}>
//                             <div style={{ width: "100%", display: "flex", flexWrap: "wrap", gap: "10px" }}>
//                               <div style={{ width: "100%" }}>
//                                 <Skeleton thickness={6} shape="circle" width="50px" height="50px" />
//                                 <div style={{ width: "75%" }}>
//                                   <Skeleton lines={3} thickness={1} />
//                                 </div>
//                                 <Skeleton lines={1} thickness={3} />
//                               </div>
//                             </div>
//                           </div>
//                         ))
//                       ) : (
//                         <>
//                           <div></div>
//                           <div></div>
//                           <div></div>
//                           <div style={{ backgroundColor: mode ? "#2C2E33" : "#fff" }}>
//                             <NoDataFound
//                               icon={<TemplateNotFound />}
//                               textTitle={`No Data Found`}
//                             />

//                           </div>
//                           <div> </div>
//                           <div></div>
//                           <div> </div>
//                         </>
//                       )
//                     )
//                       :
//                       dealerData.map((dealer, index) => (
//                         <div key={index} onClick={() => {
//                           if (designation === "ordermanager") {
//                             // handleUpdate(dealer)
//                           }

//                         }} >
//                           <DealerInfoCard
//                             whatappNo={dealer?.dealerId}
//                             dealerName={dealer?.name}
//                             imageUri={dealer?.profileImage}
//                             dealerStatus={dealer?.status}
//                             dealerDesignation={dealer?.designation}
//                             dealerLocation={dealer?.storeName}
//                           />
//                         </div>
//                       ))}
//                   </Suspense>
//                 </div>
//               </div>
//               {loading &&
//                 <div className={styles.Spinner} >
//                   <div> <Spinner size='30' /> </div>
//                 </div>
//               }
//             </div>
//           </div>
//           <div className={styles.pageContiner} style={{ backgroundColor: mode ? "#232529" : "#fff" }}>
//             <div style={{ width: "50%", display: "flex", justifyContent: "flex-start", }} >
//               <GoToPage currentPage={page} setCurrentPage={setPage} totalPages={pages} key={"1"} />
//             </div>
//             <div style={{ display: "flex", justifyContent: "flex-end", width: "50%", }} >
//               <Pagenation currentPage={page} setCurrentPage={setPage} totalPages={pages} key={"1"} /></div>
//           </div>


//           <div className={mode ? styles.md_Main_continer : styles.md_Main_continer_dark}>
//             <div className={mode ? styles.Md_continer : styles.Md_continer_dark}>
//               {
//                 dealerStatusData.map((item, i) => {
//                   return (<div style={{
//                     display: "flex",
//                     width: "32%",
//                   }}
//                     onClick={() => setSearchDealerData((pre) => ({
//                       ...pre, status: item.statusText === "All" ? "" : item.statusText
//                     }))} key={i}>
//                     <FilterCard name={item.statusText} number={item.statusItemCount} key={i} />
//                   </div>
//                   )
//                 })
//               }
//             </div>
//             <div className={styles.SearchFilter} >
//               <div className={styles.SearchCon}>
//                 <div className={mode ? styles.SearchInput_dark : styles.SearchInput} >
//                   <input type="text" placeholder='Search..'
//                     className={mode ? styles.inptage_dark : styles.inptage}
//                     onChange={(e) => setSearchDealerData({ ...searchDealerData, searchDealerName: e.target.value })} />
//                 </div>
//                 <div style={{ minWidth: "40px", minHeight: "40px", border: "1px solid #EEEEE", justifyContent: "center", display: "flex", borderRadius: "6px", background: "#E4E7EB", width: "15%", height: "43px", }}>
//                   <span className={styles.arroIcon}>
//                     <ArroIcon mode={mode} />
//                   </span>
//                 </div>
//                 <button className={styles.addbtnmd} onClick={addDelalerModel} >{"+ Add Dealer"}</button>
//               </div>
//               <div>
//               </div>
//             </div>

//             <div className={styles.md_card_Continer} >
//               {dealerData.length === 0 ? <div>
//                 {loading ?
//                   <span style={mode ? { color: "white" } : { color: "black" }}>loading..</span> :
//                   <span style={mode ? { color: "white" } : { color: "black" }}>No Data Found.</span>}

//               </div> :
//                 dealerData.map((dealer, index) => (
//                   <div key={index} style={{ width: "100%", marginBottom: "10px", minWidth: "360px" }}>
//                     <DealerCartMobil
//                       dealerName={dealer?.name}
//                       dealerStatus={
//                         dealer?.status === "New" ? "new" :
//                           dealer?.status === "Update" ? "active" :
//                             dealer?.status === "Pending" ? "pending" :
//                               dealer?.status === "Verified" ? "active" :
//                                 dealer?.status === "Rejected" ? "rejected" :
//                                   dealer?.status === "Deleted" ? "rejected" : null
//                       }
//                       dealerDesignation={dealer?.designation}
//                       dealerLocation={dealer?.storeName}
//                       imgUri={dealer?.profileImage}
//                     />
//                   </div>
//                 ))}
//               <div>
//               </div>
//             </div>
//           </div>

//         </div>
//       </div>

//     </React.Fragment>
//   )
// }

// export default Dealers

























import React, { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { useNavigate, } from 'react-router-dom';
import { useAuth } from '../../components/context/Auth';
import { CrossRedIcon, DoubleCheckIcon, Spinner } from '../../components/icons/Icon';
import styles from "./Dealer.module.css";
import ModalWrapper from '../../components/updatedComponents/layoutWrapper/ModalWrapper';
import { ArroIcon, CreateTem, TemplateNotFound, Transfer, WhatAppIcon, } from '../../components/icons/Icon2';
// import SlidingFilter from '../../components/updatedComponents/Dealers/SlidingFilter';
import DealerStatusCard from '../../components/updatedComponents/Dealers/DealerStatusCard';
import SearchBar from '../../components/updatedComponents/FormComponents/SearchBar';
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import AdduserModel from '../../components/updatedComponents/models/AdduserModel';
import FilterCard from '../../components/updatedComponents/MobilCard/FilterCard';
import DealerCartMobil from '../../components/updatedComponents/MobilCard/DealerCartMobil';
import Pagenation from "../../components/updatedComponents/Pagnation/Pagenation";
import GoToPage from '../../components/updatedComponents/Pagnation/GoToPage';
import Skeleton from '../../components/updatedComponents/Skeleton/Skeleton';
import fetchData from '../../APIsControll/apiControll';
import { useToast } from '../../components/updatedComponents/Toaster/Toaster';
import InputTag from '../../components/updatedComponents/FormComponents/InputTag';
import Button from '../../components/updatedComponents/Dealers/Button';
import TopTabBar from '../../components/updatedComponents/Tanolet/TopTabBar';
import LocationSarchFilter from '../../components/updatedComponents/Filter/LocationSarchFilter';
import NoDataFound from '../../components/updatedComponents/NoDataFound/NoDataFound';
import useWindowWidth from '../../components/updatedComponents/Hooks/WidthSize';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCityData, setDistrictData, setPage,
  setSearchDealerData, setStateData
} from '../../store/slices/dealer/DealerSlice';
import SlidingFilter2 from '../../components/updatedComponents/Dealers/SlidingFilter2';

const DealerInfoCard = lazy(() => import("../../components/updatedComponents/Dealers/DealerInfoCard"));
const TempletSent = lazy(() => import("../../components/updatedComponents/Dealers/TempletSent"));


const Dealers = () => {
  const { mode, designation } = useAuth();
  const { show } = useToast();
  const navigate = useNavigate();
  // const [page, setPage] = useState(1);
  const [isloading, setIsLoading] = useState({ Isloading1: false });
  const [chackState, setChackState] = useState({ chackStates: false });
  const [selectTemp, setSelectTemp] = useState("Select Template");
  const [showSelectTemp, setShowSelectTemp] = useState(false);
  const [dealerData, setDealerData] = useState([]);
  const [dealerNumber, setDealerNumber] = useState([]);
  const { managerId } = useAuth();
  const [loading, setLoading] = useState(false);
  const width = useWindowWidth();
  const [showMessengerModal, setShowMessengerModal] = useState(false);
  const [sendTemplateModal, setSendTemplateModal] = useState(false);
  const [sendTemplateText, setSendTemplateText] = useState('');
  const [allTemplate, setAllTemplate] = useState([]);
  const [singleTemplate, setSingleTemplate] = useState({});
  const [messengerTemplate, setMessengerTemplate] = useState();
  const [dealerNames, setDealerNames] = useState([]);
  const [showDealerNames, setShowDealerNames] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState([]);
  const [templateError, setTemplateError] = useState();
  const [templateDataLoading, setTemplateDataLoading] = useState(false);
  const [sendStatus, setSendStatus] = useState({});
  const [allfilter, setAllFilter] = useState([]);
  const [page1, setPage1] = useState(1);
  const [pages1, setPages1] = useState(1);
  const [pages, setPages] = useState(1);
  const [addDealerModelOpen, setAddDealerModelOpen] = useState(false);
  const debounceTimeout = useRef();
  const { searchDealerData, state, district, city, page } = useSelector((state) => state.dealer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!managerId) return;
    const getDealers = async () => {
      try {
        setLoading(true);
        const res = await fetchData(`kyc/dealers?page=${page}&limit=${32}`, {
          managerId,
          keyword: searchDealerData.searchDealerName,
          sortKey: searchDealerData.sortKey,
          status: searchDealerData.status,
          day: searchDealerData.dateFilter === 'All' ? '' : searchDealerData.dateFilter.toLocaleLowerCase(),
          locations: {
            states: state.selectFilter,
            districts: district.selectFilter,
            cities: city.selectFilter,
            pincodes: [],
          }
        });

        if (res.status === 'success') {
          setAllFilter(res);
          if (res?.data) {
            setDealerData(res.data);
            setPages(res.pages || 1);
          }
        } else if (res.status === 'failed') {
          setDealerData([]);
          // setPage(1);
          dispatch(setPage(1));
        } else {
          show('Error', 'error');
        }
      } catch (error) {
        show('An unexpected error occurred', 'error');
      } finally {
        setLoading(false);
      }
    };

    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      getDealers();
    }, 600);

    return () => {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managerId, page, searchDealerData, state.selectFilter, district.selectFilter, city.selectFilter]);

  useEffect(() => {
    const getDealerLoction = async () => {
      try {
        const payload = {
          managerId: managerId,
          stateSearch: "",
          districtSearch: "",
          citySearch: "",
          pincodeSearch: "",
          locations: {
            states: [],
            districts: [],
            cities: [],
            pincodes: []
          }
        }
        const res = await fetchData(`wallikonCampaign/filterLocation`, payload);
        dispatch(setDistrictData({ locationList: res?.data?.districts || [] }));
        dispatch(setStateData({ locationList: res?.data?.states || [] }));
        dispatch(setCityData({ locationList: res?.data?.cities || [] }));

      } catch (error) {

      }
    }
    getDealerLoction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managerId])

  const dealerNumberData = async () => {
    const res = await fetchData(`kyc/dealerWhatsapp`, { "managerId": managerId });
    if (res.status === "success") {
      setDealerNumber(res?.dealerWhatsapp);
      // setDealerNumber([
      //   {
      //     "dealerId": 9161048556,
      //     "name": "Mohit",
      //     "whatsapp": 9161048556
      //   },
      //   {
      //     "dealerId": 6392457271,
      //     "name": "Anshu Bhai",
      //     "whatsapp": 6392457271
      //   },
      //   {
      //     "dealerId": 9151637187,
      //     "name": "Asmit Bhai",
      //     "whatsapp": 9151637187
      //   }
      // ]);
      return
    }
    if (res.status === "failed") {
      show(`${res?.msg}`, "error");
      return
    } else {
      show(`Error`, "error");
    }
  };

  useEffect(() => {
    if (managerId) {
      if (designation === "superadmin") {
        dealerNumberData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managerId]);

  useEffect(() => {
    if (dealerData.dealerId) {
      navigate("/dealers/" + dealerData?.dealerId)
    }
  }, [dealerData.dealerId, navigate]);

  const addDelalerModel = () => {
    setAddDealerModelOpen(!addDealerModelOpen);
  }
  const TempletSentModel = () => {
    setShowMessengerModal(!showMessengerModal);
  }
  const itemList = ["All", "Today", "Yesterday", "Month"];

  const dealerStatusData = [
    { statusText: "All", statusItemCount: allfilter?.total || 0 },
    { statusText: "New", statusItemCount: allfilter?.statusCounts?.New || 0 },
    { statusText: "Verified", statusItemCount: allfilter?.statusCounts?.Verified || 0 },
    { statusText: "Pending", statusItemCount: allfilter?.statusCounts?.Pending || 0 },
    { statusText: "Update", statusItemCount: allfilter?.statusCounts?.Update || 0 },
    { statusText: "Rejected", statusItemCount: allfilter?.statusCounts?.Rejected || 0 },
    { statusText: "Deleted", statusItemCount: allfilter?.statusCounts?.Deleted || 0 },
    { statusText: "Blacklisted", statusItemCount: allfilter?.statusCounts?.Blacklisted || 0 },
  ];

  const updateDateFilter = (selectedDate) => {
    dispatch(setSearchDealerData({ dateFilter: selectedDate }));
  };

  // const containerRef = useRef(null);
  // const handleScroll = () => {
  //   const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
  //   const bottom = Math.abs(scrollHeight - scrollTop - clientHeight) <= 5;
  //   if (bottom && !loading) {
  //     if (page >= pages) {
  //       return;
  //     } else {
  //       setPage((prevPage) => Number(prevPage) + 1);
  //     }
  //   }
  // };
  // useEffect(() => {
  //   const container = containerRef.current;
  //   if (container) {
  //     container.addEventListener('scroll', handleScroll);
  //   }
  //   return () => {
  //     if (container) {
  //       container.removeEventListener('scroll', handleScroll);
  //     }
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [loading, page]);

  async function getTemplates() {
    if (managerId) {
      if (page1 <= pages1) {
        setIsLoading({ ...isloading, Isloading1: true });
        const res = await fetchData(`wallikonChat/templateList?page=${page1 <= pages1 ? page1 : pages1}&&limit=10`, {
          "managerId": managerId
        });
        if (res?.status === 'success') {
          const newTemplates = res?.data || [];
          const filteredTemplates = newTemplates.filter(newTemplate =>
            !allTemplate.some(existingTemplate =>
              existingTemplate.templateName === newTemplate.templateName
            )
          );
          setAllTemplate([...allTemplate, ...filteredTemplates]);
          setPages1(res?.pages);
          setIsLoading({ ...isloading, Isloading1: false });
          return
        }
        if (res?.status === 'failed') {
          show(`${res?.msg}`, "error");
          setIsLoading({ ...isloading, Isloading1: false });
          return
        } else {
          show(`Error`, "error");
          setIsLoading({ ...isloading, Isloading1: false });
        }
      }
    }
  };

  useEffect(() => {
    if (designation === "superadmin") {
      getTemplates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page1]);

  const handleSelectAllNumber = () => {
    setSelectedNumber(dealerNumber.map(number => number?.whatsapp));
  };

  const getChunks = (data, size) => {
    let result = [];
    for (let i = 0; i < data.length; i += size) {
      result.push(data.slice(i, i + size));
    }
    return result;
  };

  const chunkSize = 1000;
  const chunks = getChunks(dealerNumber, chunkSize);

  async function sendSingleMessage(index) {
    const myHeaders = new Headers();
    myHeaders.append("wa-platform", process.env.REACT_APP_ADMIN_SECRET);
    myHeaders.append("Content-Type", "application/json");

    const rawData = {
      managerId: managerId,
      dealerPhoneNumber: selectedNumber,
      templateName: singleTemplate.templateName,
      languageCode: singleTemplate.language,
      headerType: singleTemplate.headerType,
      headerId: singleTemplate.headerId,
    };

    if (singleTemplate.headerType === "document") {
      rawData.documentFilename = singleTemplate.documentName;
    }

    if (singleTemplate.headerType === "location") {
      rawData.latitude = "26.8428008";
      rawData.longitude = "80.9359821";
      rawData.locationName = "Wallicon Private Limited";
      rawData.locationAddress = "Wallicon, Burlington, Aminabad Road, Lucknow";
    }

    const raw = JSON.stringify(rawData);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const controller = new AbortController();
    const signal = controller.signal;
    const timeoutId = setTimeout(() => controller.abort(), 300000);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL}wallikonChat/sendTemplate?page=${index + 1}`,
        { ...requestOptions, signal }
      );
      const result = await response.json();
      clearTimeout(timeoutId);

      if (result.status === "failed") {
        alert(result.msg);
        setTemplateError(result.msg);
      }
      setSendStatus(result.response);

      return result.results || [];

    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === "AbortError") {
        console.error("Request timeout, it took too long");
      } else {
        console.error(error);
      }
      return [];
    }
  }

  const handleAddTemplateRecord = async (statusInfo) => {
    await fetchData("wallikonChat/addUpTempstatus", {
      "managerId": managerId,
      "templateName": singleTemplate.templateName,
      "statusInfo": statusInfo
    });
  }

  const processResult = (results) => {
    const newStatusArray = dealerNumber.map(dealer => {
      const foundResult = results.find(result => {
        const input = result?.data?.contacts?.[0]?.input || result?.data?.to;
        return input && (input.toString() === dealer.whatsapp.toString());
      });

      return {
        whatsapp: dealer.whatsapp,
        name: dealer.name,
        status: foundResult?.status || 'failed'
      };
    });

    setDealerNames(newStatusArray);
    handleAddTemplateRecord(newStatusArray);
  };

  async function sendAllMessages() {
    setTemplateDataLoading(true);
    const allResults = [];
    for (let i = 0; i < chunks.length; i++) {
      const pageResults = await sendSingleMessage(i);
      allResults.push(...pageResults);
    }
    setTemplateDataLoading(false);
    processResult(allResults);
  };

  useEffect(() => {
    setMessengerTemplate(selectTemp);
    const selectedTemplate = allTemplate.find(item => item?.templateName === selectTemp);
    if (selectedTemplate) {
      setSingleTemplate(selectedTemplate);
    } else if (selectTemp === 'custom_value') {
      setSingleTemplate({ templateName: 'custom_value' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectTemp]);

  const handleChack = (e) => {
    if (e === true /* && selectTemp !== "Select Template" */) {
      handleSelectAllNumber();
      setChackState({ ...chackState, chackStates: true });
      return;
    }
    else {
      setChackState({ ...chackState, chackStates: false })
    }
  };

  const handleSendTemplate = () => {
    setShowDealerNames(true);
    sendAllMessages();
    setShowMessengerModal(false);
  };

  const handeclose = () => {
    setShowDealerNames(false);
    setSendTemplateText('');
  };


  return (
    <React.Fragment>

      <ModalWrapper isOpen={showMessengerModal} onClose={TempletSentModel}>
        <Suspense fallback={
          <div className={styles.TempContiner} style={{ backgroundColor: mode ? "#232529" : "#fff" }}>
            <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
              <div style={{ width: "30%" }}>
                <Skeleton lines={1} thickness={3} />
              </div>
              <div style={{ width: "90%", alignSelf: "center", marginTop: "10px" }}>
                <Skeleton lines={1} thickness={5} />
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                  <div style={{ width: "30%" }} > <Skeleton lines={1} thickness={3} />  </div>
                  <div style={{ width: "30%" }} > <Skeleton lines={1} thickness={3} />  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div style={{ width: "48%" }} > <Skeleton lines={1} thickness={5} />  </div>
                  <div style={{ width: "48%" }} > <Skeleton lines={1} thickness={5} />  </div>
                </div>
              </div>
            </div>
          </div>
        }>
          <TempletSent
            selectTemp={selectTemp}
            setSelectTemp={setSelectTemp}
            setShowSelectTemp={setShowSelectTemp}
            showSelectTemp={showSelectTemp}
            templist={allTemplate}
            page={page1}
            pages={pages1}
            setPage={setPage1}
            loading={isloading?.Isloading1}
            closeBtn={TempletSentModel}
            SendTemplateModal={setSendTemplateModal}
            chackValue={handleChack}
            disabledValue={chackState.chackStates}
            selectedNumber={selectedNumber}
            key={"1"}
          />
        </Suspense>
      </ModalWrapper>

      <ModalWrapper isOpen={sendTemplateModal} onClose={() => setSendTemplateModal(!sendTemplateModal)}>
        <div className={styles.text_center} style={{ backgroundColor: mode ? "#2C2E33" : "#fff", color: mode ? "#fff" : "#000" }}   >
          <div className={styles.textContiner}>
            <span className={styles.TempContinerText}>Send Template </span>
            <p className={`${styles.message}`}>Price of Template sending is <span style={{ color: "#F93E3E" }} >{selectedNumber.length * (singleTemplate.category === 'MARKETING' ? 0.73 : singleTemplate.category === 'UTILITY' ? 0.30 : 0)}</span></p>
            <InputTag
              labelText={"Type Send For Send"}
              name={"temp"}
              maxLength={4}
              required={true}
              star={true}
              placeholderText={"Type Send"}
              placeholderType={"text"}
              onChange={(e) => setSendTemplateText(e.target.value)}
              value={sendTemplateText}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSendTemplate();
                }
              }}
            />

            <div className={styles.massageModal_btn}>
              <Button buttonBgColor={"#000"}
                buttonTextColor={"#fff"}
                buttonText={"No"}
                buttonClick={() => {
                  setSendTemplateModal(false);
                  // setSelectedNumber([]);
                  setMessengerTemplate()
                }} />
              <Button
                buttonText={"Yes"}
                buttonTextColor={"#fff"}
                buttonBgColor={"#4164E3"}
                disabledButtonBgColor={"#2f4697"}
                disabledButtonTextColor={"#646B88"}
                disabled={sendTemplateText.toUpperCase() === 'SEND' ? false : true}
                buttonClick={handleSendTemplate}
              />
            </div>
          </div>
        </div>
      </ModalWrapper>

      <ModalWrapper isOpen={showDealerNames} onClose={() => setShowDealerNames(!showDealerNames)}>
        <div className={styles.text_center} style={{ backgroundColor: mode ? "#2C2E33" : "#fff", color: mode ? "#fff" : "#000" }}   >
          <div className={styles.AbortControllerCon}>
            <span className={styles.template_name}>{messengerTemplate + ' Template Sent'}</span>
          </div>
          <div className={styles.dealerNames_div}>
            {dealerNames && dealerNames.map((item, index) =>
              <div key={index} className={styles.dealerNames}><span>{index + 1}&nbsp;</span>
                <span className='me-1'>{item?.name}-{item?.whatsapp}</span>
                <span>{item?.status === 'success' ? <DoubleCheckIcon /> :
                  item?.status === 'not send' ? 'not send' : <CrossRedIcon />}</span></div>)}
          </div>
          {templateError ?
            <p className='text-center'>{templateError}</p>
            :
            <>
              {templateDataLoading ? <Spinner css={styles.spinnerWhite} size="24" /> :
                <div className='d-flex justify-content-between'>
                  <div style={{ color: "#4164E3" }}>Total - {sendStatus.total && sendStatus.total}</div>
                  <div style={{ color: "green" }}>Success - {sendStatus.successful && sendStatus.successful}</div>
                  <div style={{ color: "red" }}>Failed - {sendStatus.failed && sendStatus.failed}</div>
                </div>}
            </>
          }
          <div className={styles.dealerNameModal_btn}>
            <Button buttonBgColor={"#000"} buttonText={"CLOSE"} buttonTextColor={"#fff"} buttonClick={handeclose} />
            {/* <GreenOutButton title="CLOSE"
              handleSubmit={() => {
              setShowDealerNames(false); 
              setSelectedNumber([]); 
              setMessengerTemplate(); 
              setSendTemplateText('');
               }} /> */}
          </div>
        </div>
      </ModalWrapper>

      <ModalWrapper isOpen={addDealerModelOpen} onClose={addDelalerModel} text={"Add Dealer"} closeBtn={true}>
        <div>
          <div style={{ height: "10px" }}></div>
          <AdduserModel focus={true} close={addDelalerModel} />
        </div>
      </ModalWrapper>


      <div className={styles.right_main}>
        <div className={styles.sacandMainCon} style={{ backgroundColor: mode ? "#2C2E33" : "#fff" }}>
          <div className={width > 380 ? (mode ? styles.Dealer_main_container :
            styles.Dealer_main_container_white) : 'default-class'}>
            <div className={styles.addDealers}>
              {width < 1130 ? null : <div><TopTabBar text={"Dealer"} /></div>}
              <div className={styles.btnContiner}
                style={{ display: "flex", flexDirection: "column", justifyContent: "center" }} >
                <div style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "flex-start", }} >
                  <div>
                    <SlidingFilter2
                      selectedItem={searchDealerData.dateFilter}
                      itemList={itemList}
                      setFilter={updateDateFilter}
                    />
                  </div>
                  <div style={{ display: "flex", gap: "8px" }} >
                    {
                      width > 947 ?
                        designation === "superadmin" ?
                          <div>
                            <Button
                              buttonBgColor={"#fff"}
                              buttonText={"Messenger"}
                              buttonTextColor={"#647BB9"}
                              buttonIcon={<WhatAppIcon />}
                              buttonClick={() => {
                                setShowMessengerModal(true);
                                dealerNumberData();
                              }}
                            />
                          </div> : null : null
                    }
                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                      {designation === "superadmin" ?
                        <div>
                          <Button
                            buttonBgColor={"#000000"}
                            buttonText={"Transfer Dealer"}
                            buttonTextColor={"#fff"}
                            buttonIcon={<Transfer />}
                            buttonClick={() => navigate("/dealers/transferdealer")}
                          />
                        </div> : null
                      }
                      <div>
                        <Button
                          buttonBgColor={"#4164E3"}
                          buttonText={"Add Dealer"}
                          buttonIcon={<CreateTem />}
                          buttonTextColor={"#fff"}
                          buttonClick={() => setTimeout(() => {
                            addDelalerModel()
                          }, 100)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ width: "100%", position: "relative", height: "100%", marginTop: "10px" }}>
              <div className={styles.test_middle}
                style={mode ? { backgroundColor: "#232529", position: "relative", overflow: "hidden" } :
                  { position: "relative", overflow: "hidden" }}
              >
                <Suspense fallback={<>
                  {Array.from({ length: 5 }).map((_, i) =>
                    <div style={{ height: "100%", width: "150px", }} key={i}>
                      <div style={{ height: "2rem", width: "50%" }}>
                        <Skeleton thickness={2} shape='circle' />
                      </div>
                      <Skeleton thickness={4} lines={2} />
                    </div>
                  )}
                </>}>
                  <div style={{ width: "100%", display: "flex", overflowX: "scroll", gap: "8px" }}
                    className={styles.scrollable}>
                    {dealerStatusData.map((status, index) => (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          minWidth: "160px",
                          width: "100%",
                          cursor: "pointer"
                        }}
                        key={index}
                        onClick={() => {
                          dispatch(setSearchDealerData({ status: status?.statusText }));
                          setPages(1);
                        }}
                        className={`${styles.receipts_filter} ${mode ? styles.receipts_filter_dark : ""
                          } ${status.statusText === searchDealerData.status
                            ? mode
                              ? styles.receipts_filter_active_dark
                              : styles.receipts_filter_active
                            : ""
                          }`}
                      >
                        <DealerStatusCard
                          dealerStatus={status?.statusText}
                          statusText={status?.statusText}
                          statusItemCount={status?.statusItemCount}
                        />
                      </div>
                    ))}
                  </div>
                </Suspense>
              </div>
            </div>

            <div className={styles.test_bottom}
              style={mode ? { backgroundColor: "#2C2E33", } :
                { backgroundColor: "#F8F9FC" }}>
              {width < 669 ? null :
                <div className={styles.test_bottom_top}>
                  <Suspense fallback={<div>Loading..</div>}>
                    <div className={styles.filterContiner}>
                      <div className={styles.filterserch} >
                        <SearchBar
                          onChange={(e) => dispatch(setSearchDealerData({ searchDealerName: e.target.value }))}
                          placeholder={"Search..."}
                          fontSize={12}
                        />
                      </div>
                      <div className={styles.test_bottom_top_right}>
                        <LocationSarchFilter
                          text={"State"}
                          list={state.locationList}
                          search={state.searchValue}
                          setSearch={(value) => dispatch(setStateData({ searchValue: value }))}
                          selectFilter={state.selectFilter}
                          setSelectFilter={(value) =>
                            dispatch(setStateData({ selectFilter: value }))
                          }
                        />
                        <LocationSarchFilter
                          text={"District"}
                          list={district.locationList}
                          search={district.searchValue}
                          setSearch={(value) =>
                            dispatch(setDistrictData({ searchValue: value }))
                          }
                          selectFilter={district.selectFilter}
                          setSelectFilter={(value) =>
                            dispatch(setDistrictData({ selectFilter: value }))
                          }

                        />
                        <LocationSarchFilter
                          text={"City"}
                          list={city.locationList}
                          search={city.searchValue}
                          setSearch={(value) => dispatch(setCityData({ searchValue: value }))}
                          selectFilter={city.selectFilter}
                          setSelectFilter={(value) =>
                            dispatch(setCityData({ selectFilter: value }))
                          }
                        />

                        <DropDown label={"Sort By"} options={[
                          { label: "Referral", value: "Referral" },
                          { label: "Without OTP", value: "Without OTP" },
                          { label: "Managers Created", value: "Managers Created" },
                          { label: "Self Created", value: "Self Created" },
                          { label: "Ascending", value: "Ascending" },
                          { label: "Descending", value: "Descending" },
                        ]}
                          onSelect={(val) => dispatch(setSearchDealerData({ sortKey: val.value }))}
                          onReject={() => dispatch(setSearchDealerData({ sortKey: "" }))}
                        />
                      </div>
                    </div>
                  </Suspense>
                </div>
              }
              <div className={styles.mainIS}>
                <div className={styles.test_bottom_bottom}/*  ref={containerRef} */ >
                  <Suspense fallback={
                    <div style={{ width: "100%", display: "flex", flexWrap: "wrap", gap: "10px", }} >
                      {Array.from({ length: 28 }).map((_, i) =>
                        <div style={{ width: "19%" }} key={i} >
                          <Skeleton thickness={6} shape='circle' width='50px' height='50px' />
                          <div style={{ width: "75%" }}> <Skeleton lines={3} thickness={1} />  </div>
                          <Skeleton lines={1} thickness={3} />
                        </div>
                      )}
                    </div>}>
                    {dealerData.length === 0 ? (
                      loading ? (
                        Array.from({ length: 28 }).map((_, index) => (
                          <div key={index} style={{ width: "100%" }}>
                            <div style={{ width: "100%", display: "flex", flexWrap: "wrap", gap: "10px" }}>
                              <div style={{ width: "100%" }}>
                                <Skeleton thickness={6} shape="circle" width="50px" height="50px" />
                                <div style={{ width: "75%" }}>
                                  <Skeleton lines={3} thickness={1} />
                                </div>
                                <Skeleton lines={1} thickness={3} />
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div style={{ backgroundColor: mode ? "#2C2E33" : "#fff" }}>
                            <NoDataFound
                              icon={<TemplateNotFound />}
                              textTitle={`No Data Found`}
                            />
                          </div>
                          <div> </div>
                          <div></div>
                          <div> </div>
                        </>
                      )
                    )
                      :
                      dealerData.map((dealer, index) => (
                        <div key={index} onClick={() => {
                          if (designation === "ordermanager") {
                            // handleUpdate(dealer)
                          }

                        }} >
                          <DealerInfoCard
                            whatappNo={dealer?.dealerId}
                            dealerName={dealer?.name}
                            imageUri={dealer?.profileImage}
                            dealerStatus={dealer?.status}
                            dealerDesignation={dealer?.designation}
                            dealerLocation={dealer?.storeName}
                          />
                        </div>
                      ))}
                  </Suspense>
                </div>
              </div>
              {loading &&
                <div className={styles.Spinner} >
                  <div> <Spinner size='30' /> </div>
                </div>
              }
            </div>
          </div>

          <div className={styles.pageContiner} style={{ backgroundColor: mode ? "#232529" : "#fff" }}>
            <div style={{ width: "50%", display: "flex", justifyContent: "flex-start", }} >
              <GoToPage
                currentPage={page}
                // setCurrentPage={setPage}
                setCurrentPage={(newPage) => dispatch(setPage(newPage))}
                totalPages={pages}
                key={"1"} />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", width: "50%", }} >
              <Pagenation
                currentPage={page}
                // setCurrentPage={setPage}
                setCurrentPage={(newPage) => dispatch(setPage(newPage))}
                totalPages={pages}
                key={"1"} />
            </div>
          </div>

          <div className={mode ? styles.md_Main_continer : styles.md_Main_continer_dark}>

            <div className={mode ? styles.Md_continer : styles.Md_continer_dark}>
              {
                dealerStatusData.map((item, i) => {
                  return (<div style={{
                    display: "flex",
                    width: "32%",
                  }}
                    onClick={() => setSearchDealerData((pre) => ({
                      ...pre, status: item.statusText === "All" ? "" : item.statusText
                    }))} key={i}>
                    <FilterCard name={item.statusText} number={item.statusItemCount} key={i} />
                  </div>
                  )
                })
              }
            </div>

            <div className={styles.SearchFilter} >
              <div className={styles.SearchCon}>
                <div className={mode ? styles.SearchInput_dark : styles.SearchInput} >
                  <input type="text" placeholder='Search..'
                    className={mode ? styles.inptage_dark : styles.inptage}
                    onChange={(e) => setSearchDealerData({ ...searchDealerData, searchDealerName: e.target.value })} />
                </div>
                <div style={{ minWidth: "40px", minHeight: "40px", border: "1px solid #EEEEE", justifyContent: "center", display: "flex", borderRadius: "6px", background: "#E4E7EB", width: "15%", height: "43px", }}>
                  <span className={styles.arroIcon}>
                    <ArroIcon mode={mode} />
                  </span>
                </div>
                <button className={styles.addbtnmd} onClick={addDelalerModel} >{"+ Add Dealer"}</button>
              </div>
              <div>
              </div>
            </div>

            <div className={styles.md_card_Continer} >
              {dealerData.length === 0 ? <div>
                {loading ?
                  <span style={mode ? { color: "white" } : { color: "black" }}>loading..</span> :
                  <span style={mode ? { color: "white" } : { color: "black" }}>No Data Found.</span>}

              </div> :
                dealerData.map((dealer, index) => (
                  <div key={index} style={{ width: "100%", marginBottom: "10px", minWidth: "360px" }}>
                    <DealerCartMobil
                      dealerName={dealer?.name}
                      dealerStatus={
                        dealer?.status === "New" ? "new" :
                          dealer?.status === "Update" ? "active" :
                            dealer?.status === "Pending" ? "pending" :
                              dealer?.status === "Verified" ? "active" :
                                dealer?.status === "Rejected" ? "rejected" :
                                  dealer?.status === "Deleted" ? "rejected" : null
                      }
                      dealerDesignation={dealer?.designation}
                      dealerLocation={dealer?.storeName}
                      imgUri={dealer?.profileImage}
                    />
                  </div>
                ))}
              <div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </React.Fragment>
  )
}

export default Dealers

